import React, { useState } from "react";
import "@fontsource/inter/400.css";
import "@fontsource/inter/500.css";
import "@fontsource/inter/600.css";
import "@fontsource/inter/700.css";
import "@fontsource/geist/400.css";
import "@fontsource/geist/500.css";
import "@fontsource/geist/600.css";
import "@fontsource/geist/700.css";
import "@fontsource/figtree/400.css";
import "@fontsource/figtree/500.css";
import "@fontsource/figtree/600.css";
import "@fontsource/figtree/700.css";
import "@fontsource/manrope/400.css";
import "@fontsource/manrope/500.css";
import "@fontsource/manrope/600.css";
import "@fontsource/manrope/700.css";
import "@fontsource/public-sans/400.css";
import "@fontsource/public-sans/500.css";
import "@fontsource/public-sans/600.css";
import "@fontsource/public-sans/700.css";
import "@fontsource/source-sans-3/400.css";
import "@fontsource/source-sans-3/500.css";
import "@fontsource/source-sans-3/600.css";
import "@fontsource/source-sans-3/700.css";
import "@fontsource/ibm-plex-sans/400.css";
import "@fontsource/ibm-plex-sans/500.css";
import "@fontsource/ibm-plex-sans/600.css";
import "@fontsource/ibm-plex-sans/700.css";
import "@fontsource/jetbrains-mono/400.css";
import "@fontsource/jetbrains-mono/500.css";
import "@fontsource/jetbrains-mono/600.css";
import "@fontsource/jetbrains-mono/700.css";
import "@fontsource/dm-sans/400.css";
import "@fontsource/dm-sans/500.css";
import "@fontsource/dm-sans/600.css";
import "@fontsource/dm-sans/700.css";
import "@fontsource/plus-jakarta-sans/400.css";
import "@fontsource/plus-jakarta-sans/500.css";
import "@fontsource/plus-jakarta-sans/600.css";
import "@fontsource/plus-jakarta-sans/700.css";
import "@fontsource/outfit/400.css";
import "@fontsource/outfit/500.css";
import "@fontsource/outfit/600.css";
import "@fontsource/outfit/700.css";
import "@fontsource/space-grotesk/400.css";
import "@fontsource/space-grotesk/500.css";
import "@fontsource/space-grotesk/600.css";
import "@fontsource/space-grotesk/700.css";
import "@fontsource/work-sans/400.css";
import "@fontsource/work-sans/500.css";
import "@fontsource/work-sans/600.css";
import "@fontsource/work-sans/700.css";
import "@fontsource/archivo/400.css";
import "@fontsource/archivo/500.css";
import "@fontsource/archivo/600.css";
import "@fontsource/archivo/700.css";
import "@fontsource/shantell-sans/400.css";
import "@fontsource/shantell-sans/500.css";
import "@fontsource/shantell-sans/600.css";
import "@fontsource/shantell-sans/700.css";
import "@fontsource/source-serif-4/400.css";
import "@fontsource/source-serif-4/500.css";
import "@fontsource/source-serif-4/600.css";
import "@fontsource/source-serif-4/700.css";
import "@fontsource/ibm-plex-serif/400.css";
import "@fontsource/ibm-plex-serif/500.css";
import "@fontsource/ibm-plex-serif/600.css";
import "@fontsource/ibm-plex-serif/700.css";
import "@fontsource/lora/400.css";
import "@fontsource/lora/500.css";
import "@fontsource/lora/600.css";
import "@fontsource/lora/700.css";
import "@fontsource/literata/400.css";
import "@fontsource/literata/500.css";
import "@fontsource/literata/600.css";
import "@fontsource/literata/700.css";
import "@fontsource/spectral/400.css";
import "@fontsource/spectral/500.css";
import "@fontsource/spectral/600.css";
import "@fontsource/spectral/700.css";
import "@fontsource/newsreader/400.css";
import "@fontsource/newsreader/500.css";
import "@fontsource/newsreader/600.css";
import "@fontsource/newsreader/700.css";
import "@fontsource/roboto-slab/400.css";
import "@fontsource/roboto-slab/500.css";
import "@fontsource/roboto-slab/600.css";
import "@fontsource/roboto-slab/700.css";
import "@fontsource/bitter/400.css";
import "@fontsource/bitter/500.css";
import "@fontsource/bitter/600.css";
import "@fontsource/bitter/700.css";
import "@fontsource/merriweather/400.css";
import "@fontsource/merriweather/500.css";
import "@fontsource/merriweather/600.css";
import "@fontsource/merriweather/700.css";
import "@fontsource/playfair-display/400.css";
import "@fontsource/playfair-display/500.css";
import "@fontsource/playfair-display/600.css";
import "@fontsource/playfair-display/700.css";
import "@fontsource/podkova/400.css";
import "@fontsource/podkova/500.css";
import "@fontsource/podkova/600.css";
import "@fontsource/podkova/700.css";
import "@fontsource/barlow-condensed/400.css";
import "@fontsource/barlow-condensed/500.css";
import "@fontsource/barlow-condensed/600.css";
import "@fontsource/barlow-condensed/700.css";
import "@fontsource/roboto-condensed/400.css";
import "@fontsource/roboto-condensed/500.css";
import "@fontsource/roboto-condensed/600.css";
import "@fontsource/roboto-condensed/700.css";
import "@fontsource/oswald/400.css";
import "@fontsource/oswald/500.css";
import "@fontsource/oswald/600.css";
import "@fontsource/oswald/700.css";
import "@fontsource/ibm-plex-mono/400.css";
import "@fontsource/ibm-plex-mono/500.css";
import "@fontsource/ibm-plex-mono/600.css";
import "@fontsource/ibm-plex-mono/700.css";
import "@fontsource/source-code-pro/400.css";
import "@fontsource/source-code-pro/500.css";
import "@fontsource/source-code-pro/600.css";
import "@fontsource/source-code-pro/700.css";
import "react-phone-number-input/style.css";
import { initApp } from "./store/init";
import { ThemeProvider, Alert, Button, Box } from "@mui/material";
import { observer } from "mobx-react-lite";
import { RootStoreContext } from "./store/contexts";
import { RouterProvider } from "react-router";
import { createAppRouter } from "./router/routes";
import { useVersionCheck } from "./hooks/useVersionCheck";
import { useWebVitals } from "./common/hooks/useWebVitals";
import { useKeyboardShortcut } from "./hooks/useKeyboardShortcut";
import { DownloadProgress } from "./common/components/DownloadProgress";
import { SystemStatusOverlay } from "./common/components/SystemStatusOverlay";
import { DrawerView } from "./common/layout/DrawerView";
import { ModalView } from "./common/layout/ModalView";
import { KeyboardShortcutProvider, SHORTCUTS } from "./services/keyboard";
import { InstallBanner } from "./common/components/InstallBanner";
import { UpdateNotification } from "./common/components/UpdateNotification";
import { OfflineIndicator } from "./common/components/OfflineIndicator";
import { ConfirmDialogProvider } from "./common/components/ConfirmDialogProvider";
import { AppErrorBoundary } from "./common/components/ErrorBoundary";
import { MaintenanceOverlay } from "./common/components/MaintenanceOverlay";

const store = initApp();
const { prefStore, langStore } = store;
const router = createAppRouter();

const AppContent = observer(() => {
  const { newVersionAvailable, handleUpdate } = useVersionCheck();
  const [showBanner, setShowBanner] = useState(true);

  // beforeunload es manejado por NavigationGuard dentro del router
  useWebVitals();

  useKeyboardShortcut(
    SHORTCUTS.PRIVILEGED.MONITORS,
    () => {
      store.systemMonitorStore.toggleMonitor();
    },
    {
      description: "Toggle system monitor",
      category: "Debug",
      tier: "privileged",
      preventDefault: true,
    }
  );

  return (
    <>
      {newVersionAvailable && showBanner && (
        <Box
          sx={{ position: "fixed", top: 0, left: 0, right: 0, zIndex: 9999 }}
        >
          <Alert
            severity="info"
            action={
              <>
                <Button color="inherit" size="small" onClick={handleUpdate}>
                  {langStore.updateNow}
                </Button>
                <Button
                  color="inherit"
                  size="small"
                  onClick={() => setShowBanner(false)}
                >
                  {langStore.updateLater}
                </Button>
              </>
            }
          >
            {langStore.newVersionAvailable}
          </Alert>
        </Box>
      )}
      <SystemStatusOverlay />
      <InstallBanner />
      <UpdateNotification />
      <OfflineIndicator />
      <RouterProvider router={router} />
      <DownloadProgress store={store.downloadProgressStore} />
      <DrawerView />
      <ModalView />
    </>
  );
});

export const App = observer(() => {
  return (
    <ThemeProvider theme={prefStore.theme}>
      <RootStoreContext.Provider value={store}>
        <ConfirmDialogProvider>
          <KeyboardShortcutProvider>
            <AppErrorBoundary>
              <AppContent />
            </AppErrorBoundary>
            <MaintenanceOverlay />
          </KeyboardShortcutProvider>
        </ConfirmDialogProvider>
      </RootStoreContext.Provider>
    </ThemeProvider>
  );
});
